module.exports = __webpack_public_path__ + "static/media/About-Exercise.36f14585.png";